import { IInvoice, Item } from "../../types/invoice.type";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";

const API_URL = import.meta.env.VITE_API_URL;
type GetInvoicesParams = {
  search?: string;
  status?: string[];
  page?: number;
  orderBy?: string;
};
export type GetInvoicesApiResponse = {
  ok: boolean;
  data: IInvoice[];
  totalItems: number;
  message?: string;
};
export type GetInvoiceApiResponse = {
  ok: boolean;
  data: IInvoice;
  message?: string;
};

export async function getInvoices(params: GetInvoicesParams) {
  const urlParams = new URLSearchParams();
  if (params.search) urlParams.append("search", params.search);
  if (params.page) urlParams.append("page", params.page.toString());
  if (params.status && params.status.length > 0) {
    params.status.forEach((s) => urlParams.append("status", s));
  }
  if (params.orderBy) urlParams.append("orderBy", params.orderBy);

  const url = `${API_URL}/invoice/incoming?${urlParams.toString()}`;

  const result = await makeRequest(url);
  return result as unknown as GetInvoicesApiResponse;
}

export async function getInvoiceById(id: string) {
  const url = `${API_URL}/invoice/details/${id}`;
  const result = await makeRequest(url);
  return result as GetInvoiceApiResponse;
}

const makeRequestDebounced = createDebounce(makeRequest, 200);
export async function invoicesNfeCompleted(search?: string) {
  const params = search
    ? new URLSearchParams({ search: search })
    : new URLSearchParams();
  const url = `${API_URL}/invoice/nfe-completed?${params.toString()}`;
  const result = (await makeRequestDebounced(url)) as ApiResponseType<
    IInvoice[]
  >;
  return { data: result.data };
}

export async function invoiceNfeSigle(id: string) {
  const url = `${API_URL}/invoice/nfe-itens/${id}`;
  const result = (await makeRequestDebounced(url)) as ApiResponseType<Item[]>;
  return { data: result.data };
}
export async function PurchaseOrderItem(
  invoiceId: string,
  itemNumber: string,
  Data: { purchaseOrderCode: string; purchaseOrderItemId: string }
) {
  const url = `${API_URL}/invoice/${invoiceId}/item/${itemNumber}`;
  const result = await makeRequest(url, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(Data),
  });
  return result as GetInvoiceApiResponse;
}

export async function searchPurchaseOrderByCode(code: string) {
  const url = `${API_URL}/purchase-order/search/${code}`;
  const result = await makeRequest(url);
  return result as ApiResponseType<{ _id: string; description: string }[]>;
}

export async function confirmInvoiceItems(invoiceId: string) {
  const url = `${API_URL}/invoice/${invoiceId}/confirm-items`;
  const result = await makeRequest(url, {
    method: "POST",
  });
  return result as ApiResponseType<{ message: string }>; // Ajuste o tipo de retorno conforme necessário
}
